module.exports = __webpack_public_path__ + "img/combo2.08e9be1f.png";